<template>
  <div>
    <app-title>Import Payments</app-title>
    <v-card>
      <v-card-title primary-title>
        <commissions-runs @runSelected="chooseRun"></commissions-runs>
        <div class="container" v-if="run.runId > 0 && run.runType == 1">
          <div>Download the csv version of the report `Financial->Payments By Date` for the period: {{run.dateFrom | formatDate}} - {{run.dateTo | formatDate}}</div>
          <div class="large-12 medium-12 small-12 cell">
            <label>
              File
              <input type="file" id="file" ref="file" hidden v-on:change="handleFileUpload()" />
            </label>
            <v-btn color="success" @click="chooseFile" :disabled="uploading">Choose File</v-btn>
            {{file.name}}
            <v-btn v-if="file" color="primary" v-on:click="submitFile()">Upload</v-btn>
            <v-progress-circular :width="5" color="primary" indeterminate v-if="uploading"></v-progress-circular>
          </div>
        </div>
        <div v-else>
          <v-btn color="primary" @click="importStatements">Import Statements from UB</v-btn>
          <v-progress-circular :width="5" color="primary" indeterminate v-if="importing"></v-progress-circular>
        </div>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import commsRuns from "@/components/app/commsRuns";
export default {
  name: "ImportPayments",
  components: {
    "commissions-runs": commsRuns
  },
  data () {
    return {
      uploading: false,
      runType: 1,
      runs: [],

      file: "",
      overwrite: true,
      importing: false
    };
  },
  computed: {
    ...mapState("commissions", ['run'])
  },
  methods: {
    ...mapActions("commissions", [
      "getCommissionRuns",
      "ImportPayments",
      "ImportStatement"
    ]),
    chooseRun (value) {
      this.run = value;
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0];
    },
    chooseFile () {
      this.$refs.file.click();
    },
    importStatements () {
      this.importing = true;
      this.ImportStatement(this.run.runId).then(() => {
        this.importing = false;
      });
    },
    submitFile () {
      if (this.file) {
        let formData = new FormData();
        formData.append("files", this.file);
        this.uploading = true;
        this.ImportPayments({ files: formData, runId: this.run.runId })
          .then(() => {
            this.file = "";
            this.uploading = false;
          })
          .catch(() => { });
      }
    }
  }
};
</script>

<style scoped>
</style>